<template>
  <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10349_35472)">
      <path
          d="M12.3213 8.00002C12.0254 8.00002 11.7855 8.23986 11.7855 8.53574V13.8928C11.7855 14.1887 11.5457 14.4285 11.2498 14.4285H1.60712C1.31125 14.4285 1.0714 14.1887 1.0714 13.8928V3.17865C1.0714 2.88278 1.31125 2.64294 1.60712 2.64294H8.03561C8.33148 2.64294 8.57132 2.40309 8.57132 2.10722C8.57132 1.81135 8.33148 1.57153 8.03561 1.57153H1.60712C0.719532 1.57153 0 2.29107 0 3.17865V13.8928C0 14.7804 0.719532 15.4999 1.60712 15.4999H11.2499C12.1374 15.4999 12.857 14.7804 12.857 13.8928V8.53571C12.857 8.23986 12.6171 8.00002 12.3213 8.00002Z"
          fill="currentColor"/>
      <path
          d="M7.02858 11C6.75079 11 6.473 10.8953 6.26094 10.6848L3.31809 7.76256C2.89397 7.34141 2.89397 6.6592 3.31809 6.23928C3.74222 5.81813 4.42802 5.8169 4.85214 6.23805L7.02858 8.39922L12.1479 3.31586C12.572 2.89471 13.2578 2.89471 13.6819 3.31586C14.106 3.73701 14.106 4.41923 13.6819 4.84038L7.79622 10.6848C7.58416 10.8953 7.30637 11 7.02858 11Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_10349_35472">
        <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconCheckSquare"
}
</script>